<div class="demographic-view">
  <h1 class="mat-h1 color-primary text-small-caps no-bottom-margin">{{ 'COMPETITIVE_SUMMARY' | translate }}</h1>
  <hr/>

  <div class="banner-comparison-page-container container" fxLayout="column" fxLayoutGap="15px">
    <div class="form-container" fxLayout="row" fxLayoutGap="15px">
      <div class="width100" fxLayout="row" fxLayoutAlign="space-between">
        <div class="form-container-left" fxLayout="row" fxLayoutGap="15px">
          <form [formGroup]="keyIndicatorForm">
            <mtn-key-indicator-field [form]="keyIndicatorForm"></mtn-key-indicator-field>
          </form>
        </div>
        <form [formGroup]="form">
          <div class="form-container-right" fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="15px">
            <mtn-region-field [form]="form" [isMarketAreaAvailable]="true"></mtn-region-field>
            <mtn-drive-time-minutes-field [form]="form" *ngIf="form.get('region').value === 'DRIVE_TIME'"></mtn-drive-time-minutes-field>
            <mtn-ring-miles-field [form]="form" *ngIf="form.get('region').value === 'RING'"></mtn-ring-miles-field>
          </div>
        </form>
      </div>
    </div>

    <div class="table-container condensed-table container">
      <div class="table-container condensed-table container">
        <table  #table mat-table [dataSource]="dataSource" matSort  aria-label="Sales data table">
          <ng-container matColumnDef="name">
            <th disableClear="true"  mat-header-cell *matHeaderCellDef class="banner-coloumn" scope="col" aria-label="Banner Name">{{ 'BANNER' | translate }}</th>
            <td mat-cell  *matCellDef="let element" aria-label="Banner Name">{{element.name}}</td>
          </ng-container>

          <ng-container matColumnDef="value">
            <th disableClear="true"  mat-header-cell class="header-align-right-p-and-c" *matHeaderCellDef mat-sort-header scope="col" aria-label="Total Sales">
              <span *ngIf="keyIndicatorForm.value.keyIndicator === 'SALES_VOLUME'">{{ 'TOTAL_SALES' | translate }}</span>
              <span *ngIf="keyIndicatorForm.value.keyIndicator === 'SALES_SQFT'">{{ 'SALES_PER_SQFT' | translate }}</span>
            </th>
            <td mat-cell class="data-align-right" *matCellDef="let element" aria-label="Total Sales"><span class="data-right-margin" matSortActive="value" matSortDirection="asc">{{keyIndicatorForm.value.keyIndicator === 'SALES_SQFT' ? (element.value | number:'1.2-2') : (element.value | number:'1.0-0')}}</span>  </td>
          </ng-container>

          <ng-container matColumnDef="totalCount">
            <th disableClear="true"  mat-header-cell class="header-align-right-p-and-c" *matHeaderCellDef mat-sort-header scope="col" aria-label="Total Count">{{ 'COUNT' | translate }}</th>
            <td mat-cell class="data-align-right" *matCellDef="let element" aria-label="Total Count"><span class="data-right-margin"> {{element.totalCount}}</span></td>
          </ng-container>

        <!-- "No Data Available" Row -->
        <tr *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length" class="no-data" role="row">{{ 'NO_DATA_AVAILABLE' | translate }}</td>
        </tr>

        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <!-- Data Rows -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" role="row"></tr>
      </table>

      <mat-paginator
        #paginator
        [pageSize]="10"
        [length]="totalLength"
        [pageSizeOptions]="[5, 10, 20]"
        [showFirstLastButtons]="true"
        aria-label="Table paginator">
      </mat-paginator>
    </div>

    <mtn-spinner [size]="SpinnerSize.MEDIUM" [on]="isLoading"></mtn-spinner>
  </div>
</div>
